import React, { useState, useRef, useReducer } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty, isColorBright, RGB_2_HEX } from '../../lib/ep.js';
import SaveButton from '../../components/builder/SaveButton';
import ContainedRoulette from '../../components/front/ContainedRoulette';
import NextActionButton from '../../components/games/NextActionButton.js';
import LeveledHTMLText from '../../components/front/helpers/LeveledHTMLText.js';
import ButtonCollection from '../../components/builder/ButtonCollection.js';

const reducer = (state, action) => {
	switch(action.type) {
		case 'CHANGE_STATE':
			const r = {
				...state,
				state:action.state,
			};

			if(action.state == 'GAME') r.seed = Date.now();
			return r;

		default:
			break;
	}

	return state;
}

const RouletteStage = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ displayFirstTry, setDisplayFirstTry ] = useState(true);
	const [ display_splash_screen, setDisplaySplashScreen ] = useState(false);
	const [ response, setResponse ] = useState({ spt:2 });
	const [ given_prize, setGivenPrize ] = useState(null);
	const [ participating, setParticipating ] = useState(null);

	const [ state, dispatch ] = useReducer(reducer, {
		state:'GAME',
		seed:Date.now(),
	});

	const contained_roulete = useRef(null);
	const is_button_pressed = useRef(false);

	const is_desktop = ((window?.platform ?? 'desktop') == 'desktop') ? true : false;

	const stage = props?.stage?.Stage ?? false;
	if(stage === false) return null;

	const end_animation_cb = () => {
		setDisplaySplashScreen(true);

		let redirect_to_success = false;
		if(response.prize) redirect_to_success = true;	// user has won a prize
		if(response.retries == 0) redirect_to_success = true;	// has no more retries
		if(true) redirect_to_success = true;	// we redirect always, to avoid displaying a page (no_prize) that is not configurable (2024-12-05)

		if(redirect_to_success) {
			window.location.href = response.url;
			return;
		}

		dispatch({type:'CHANGE_STATE',state:'SUCCESS'});
	};

	const spinRoulette = (cb) => {
		if(participating) return;
		if(is_button_pressed.current) return;

		is_button_pressed.current = true;
		setParticipating(true);

		$.post(`/promotions/participate/${props.promotion.Promotion.id}/${stage.id}`, { spin:true, ticket:props.ticket }, (res) => {
			if(res.status) {
				// Added this to prevent possible "null" / "undefined" / ... values in res.spt
				const parsed_spt = (!isNaN(parseInt(res.spt))) ? res.spt : 0;

				setGivenPrize(parsed_spt);

				setResponse(res);
				if(displayFirstTry) setDisplayFirstTry(false);

				if(cb != undefined) cb();
			} else if(res.url != undefined) {
				window.location.href = res.url;
			}

			setParticipating(false);
		}, 'JSON');
	};

	const resetGame = (cb) => {
		is_button_pressed.current = false;

		props.canPlayAgain(() => {
			setDisplayFirstTry(true);
			dispatch({ type:'CHANGE_STATE', state:'GAME' });
			setDisplaySplashScreen(false);
		});
	};

	const continueButton = () => {
		window.location.href = response.url;
	};

	const getPrize = (id) => {
		return props.prizes.find((p) => (p.id == id));
	};

	const bg_color = stage.roulette_data[given_prize]?.color ?? false;
	const dark_color = (bg_color && isColorBright(RGB_2_HEX(bg_color))) ? false : true;

	const no_prize_bg_color = stage?.roulette_no_prize_color ?? '#000000';
	const no_prize_dark_color = (isColorBright(RGB_2_HEX(no_prize_bg_color))) ? false : true;

	const response_classes = ['game_result', 'override_styles', 'is_fullscreen'];
	if(is_desktop) response_classes.push('relative_to_container');
	if(display_splash_screen) {
		if(response.spt == 0) {
			response_classes.push('no_prize');
			response_classes.push((no_prize_dark_color) ? 'is_dark' : 'is_light');
		} else if(response.spt > 0) {
			if(!bg_color) response_classes.push('is_ok');
			response_classes.push((dark_color) ? 'is_dark' : 'is_light');
		}
	}

	return (
		<div class="main_contents_flex gui_game_main_container gui_pos_rel">
			<div class="gui_pos_rel" style={{ height:'85svh' }}>
				{(response.spt > 0 && display_splash_screen) && (
					<div class={response_classes.join(" ")} style={(bg_color) ? { backgroundColor:bg_color } : null}>
						<div class="g">
							<div class="icon_container">
								<div class="icon ep-winners" />
							</div>

							<LeveledHTMLText
								_class={{ other:'status_title' }}
							>
								{(getPrize(given_prize) != undefined) ? (getPrize(given_prize)).title : `<h1>${i18n("Good job!")}</h1>`}
							</LeveledHTMLText>
						</div>

						<NextActionButton
							custom_color={false}
							multiparticipation={true}
							status='ok'
							allow_retry={response.retries > 1}
							retries={response.retries}
							prize={response.prize}
							next_participation={response.next_participation}
							continueGame={() => continueButton()}
							restartGame={() => resetGame()}
							button_text_color={bg_color}
							intl={props.intl}
						/>
					</div>
				)}

				{(response.spt == 0 && display_splash_screen) && (
					<div class={response_classes.join(" ")} style={{ backgroundColor:no_prize_bg_color }}>
						<div class="g">
							<div class="icon_container">
								<div class="icon knk-reaction-sad" />
							</div>

							<LeveledHTMLText
								_class={{ other:'status_title' }}
							>
								{(isNotEmpty(stage, 'roulette_no_prize_label')) ? stage.roulette_no_prize_label : `<h1>${i18n("No prize")}</h1>`}
							</LeveledHTMLText>
						</div>

						<NextActionButton
							custom_color={false}
							multiparticipation={true}
							status='ko'
							allow_retry={response.retries > 1}
							retries={response.retries}
							prize={response.prize}
							next_participation={response.next_participation}
							continueGame={() => continueButton()}
							restartGame={() => resetGame()}
							button_text_color={no_prize_bg_color}
							intl={props.intl}
						/>
					</div>
				)}
				
				<div class="is_fullscreen" style={{display:((state.state == 'GAME') ? 'block' : 'none'), zIndex:'10000'}}>
					<ContainedRoulette
						key={state.seed}
						ref={contained_roulete}
						prizes={props.prizes}
						onContinue={continueButton}
						stage={stage}
						promotion={props.promotion.Promotion}
						end_animation_cb={end_animation_cb}
						given_prize={given_prize}
						main_cta={(displayFirstTry) && (
							<ButtonCollection
								_class={{ other:'flex_button gui_big_button' }}
							>
								<SaveButton
									_fullclass="original_color_item"
									onClick={(e, cb) => spinRoulette(cb)}
									onMouseUp={(e, cb) => spinRoulette(cb)}
									onTouchEnd={(e, cb) => spinRoulette(cb)}
									enable_mobile_events={true}
									autotranslate={false}
								>{stage?.roulette_spin_it_btn_label ?? i18n("Press here")}</SaveButton>
							</ButtonCollection>
						)}
					/>
				</div>
			</div>

			{/*(displayFirstTry) && (
				<FloatingLayerPublic
					only_contents={true}
					pm={props.promotion.Promotion}
					enable_close={false}
					backButton={(e, cb) => spinRoulette(cb)}
				>
					<div class="gui_canvas_instructions">
						<div class="cta_and_info">
							<div class="gui_not_in_top_small flex_button gui_big_button register_flex">
								<SaveButton
									_fullclass=""
									onClick={(e, cb) => spinRoulette(cb)}
								>OK, got it!</SaveButton>
							</div>
						</div>

						<div class="gui_text_align_center gui_not_in_top_big gui_not_in_bottom_tiny" style={{maxWidth:'240px'}}>
							<InstructionCanvas
								color={stage.roulette_ui_color}
								container='.gui_floating_layer_react .contents'
								info_container=".cta_and_info"
								padding_container='.gui_canvas_instructions'
							/>
						</div>

						<LeveledHTMLText>
							<p>{i18n("Hold the button down to give more power")}.</p>
						</LeveledHTMLText>
					</div>
				</FloatingLayerPublic>
			)*/}
		</div>
	);
}

export default injectIntl(RouletteStage);